import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store';

export const selectSalesState = (state: RootState) => state.sales;

export const selectAllSales = createSelector([selectSalesState], (salesState) =>
  salesState.allIds.map((id) => salesState.byId[id])
);

export const selectSaleById = (saleId: string) =>
  createSelector([selectSalesState], (salesState) => salesState.byId[saleId]);

export const selectFilteredSales = createSelector(
  [selectAllSales, selectSalesState],
  (sales, salesState) => {
    const { status, search } = salesState.filters;

    return sales.filter((sale) => {
      if (status && status !== 'all' && sale.status !== status) return false;
      if (search) {
        const searchLower = search.toLowerCase();
        const matchesSearch = sale.id.toLowerCase().includes(searchLower);
        if (!matchesSearch) return false;
      }
      return true;
    });
  }
);

export const selectSalesLoading = createSelector(
  [selectSalesState],
  (salesState) => salesState.isLoading
);

export const selectSalesError = createSelector(
  [selectSalesState],
  (salesState) => salesState.error
);
